import type { TShirtSizes } from '../types'

export type GuttersType = Record<TShirtSizes | 'none', Partial<Record<TShirtSizes | 'default', number>>>

const gutters: GuttersType = {
  none: {
    default: 0,
  },
  pico: {
    default: 0.5,
    sm: 1,
    md: 2,
  },
  nano: {
    default: 2,
    md: 4,
  },
  xxs: {
    default: 4,
    md: 6,
  },
  xs: {
    default: 6,
    md: 8,
  },
  sm: {
    default: 8,
    sm: 10,
    md: 12,
  },
  md: {
    default: 10,
    xs: 12,
    sm: 14,
    md: 16,
  },
  lg: {
    default: 16,
    sm: 18,
    md: 20,
    lg: 24,
  },
  xl: {
    default: 20,
    xs: 22,
    sm: 24,
    md: 28,
    lg: 32,
  },
  xxl: {
    default: 32,
    xs: 36,
    sm: 40,
    md: 48,
    lg: 64,
  },
}

export default gutters
